module.exports = __webpack_public_path__ + "static/media/MassCom.b4f97ce8.PNG";